import React from "react";

import { Cartesian } from "@examspark/types";

export const Text: React.FC<React.PropsWithChildren<Cartesian.TextProps>> = (
  props,
) => {
  return (
    <text
      x={props.coords.x}
      y={props.coords.y}
      textAnchor={props.anchor || "end"}
    >
      {props.children}
    </text>
  );
};
